// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce/storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce/storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1b-0 button {\n  height: fit-content !important;\n  outline: none;\n}\n\n._1b-0 p {\n  font-size: inherit;\n  line-height: inherit;\n  font-weight: inherit;\n}\n\n._1b-0:hover:not(._1b-1) {\n    filter: brightness(1.1);\n  }\n", ""]);
// Exports
export var brandKitButton = "_1b-0";
export var tertiary = "_1b-1";
export default ___CSS_LOADER_EXPORT___;
